;$(function(){

	var page = {};
	page.img = $('img');
	page.zoom = $('.gallery-zoom');

	var action = {};
	action.img = {};
	action.zoom = {};
	action.img.onMouseover = function() {
		if ($(this).attr('src') != '') return;
		$(this).attr('src', $(this).data('src'));
	}
	action.zoom.onClick = function() {
		$(this).siblings('.gallery__wrapper').find('.swiper-slide-active').trigger('click');
	}

	page.img.mouseover( action.img.onMouseover );
	page.zoom.click( action.zoom.onClick );

});